import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { TaskAssignmentComponent } from './component/taskAssignment.component';

import { TableModule } from 'primeng-lts/table';
import { RadioButtonModule } from 'primeng-lts/radiobutton';
import { CheckboxModule } from 'primeng-lts/checkbox';

import { FormsModule } from '@angular/forms';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DialogModule } from 'primeng-lts/dialog';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { FormPlycaModule } from '../../components/forms/formPlyca.module';
import { DossierHeaderModule } from '../../dossiers/components/dossierHeader.module';


@NgModule({
  declarations: [TaskAssignmentComponent],
  imports: [
    TranslateModule,
    CommonModule,
    FormPlycaModule,
    FormsModule,
    TableModule,
    RadioButtonModule,
    CheckboxModule,
    DialogModule,
    SubHeaderModule,
    DossierHeaderModule,
    ScrollPanelModule
  ]
})
export class TaskAssignmentModule { }
